<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <router-view />
    </a-locale-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import enUS from "ant-design-vue/lib/locale-provider/en_US";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  data() {
    return {
      locale: zhCN
    };
  },
  watch: {
    "$route.query.locale": function(val) {
      this.locale = val === "enUS" ? enUS : zhCN;
      moment.locale(val === "enUS" ? "en" : "zh-cn");
    }
  }
};
</script>

<style lang="less">
#app {
  height: 100%;
}

.m_flex_row{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
   align-items: center;
}

.m_flex_column{
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
}

.m1{
  font-size: 24px;
  font-weight: 700;
  color: #333333;
}
.m2{
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
</style>
